<template>
  <div class="form">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button @click="validateForm()" class="btn fixed_btn">Save Form</button>
      <div class="card">
        <div class="inputs" v-if="form">
          <div class="input full">
            <label>Form Title <span class="required">*</span></label>
            <input v-model="form.title" />
          </div>
          <div class="input full">
            <label>Description</label>
            <textarea draggable="false" v-model="form.description"></textarea>
          </div>
          <div class="input full">
            <label
              >Enable Employee Attendee Status
              <span @click="helper = 'attendee_status'" class="help-icon"
                >?</span
              ></label
            >
            <div class="switch-holder">
              <switches v-model="form.attendee_status"></switches>
              <p>{{ form.attendee_status ? "Enabled" : "Disabled" }}</p>
            </div>
            <transition name="fade">
              <p v-if="helper == 'attendee_status'" class="helper">
                With this feature enabled, COVIDpad will ask each user "What are
                they are doing today." If the user selects "Going into work,"
                then they will have to answer the typical survey. If they answer
                anything else, there is no need to record survey resilts.
                <span @click="helper = null">x</span>
              </p>
            </transition>
          </div>
        </div>
      </div>
      <h3>Questions</h3>
      <draggable
        :list="form.questions"
        @start="dragging = true"
        @end="dragging = false"
      >
        <div
          class="card question"
          v-for="(question, i) in form.questions"
          :key="i"
        >
          <div class="controls">
            <img @click="editQuestion(i)" src="@/assets/img/edit.svg" />
            <img @click="removeQuestion(i)" src="@/assets/img/delete.svg" />
          </div>
          <h4>
            Question {{ i + 1 }}
            <div v-if="currently_editing[i]" class="inputs">
              <div class="input full">
                <editor v-model="question.question" />
                <!-- <textarea
                  :placeholder="question.question"
                  v-model="question.question"
                /> -->
              </div>
            </div>
            <template v-if="!currently_editing[i]">
              <span
                v-if="
                  !question.question.includes('>') &&
                    !question.question.includes('<')
                "
                >{{ question.question }}</span
              >
              <template
                v-if="
                  question.question.includes('>') &&
                    question.question.includes('<')
                "
              >
                <span v-html="question.question"></span>
              </template>
            </template>
          </h4>
          <ul>
            <li v-for="(answer, index) in question.answers" :key="index">
              {{ answer.name }}
            </li>
          </ul>
        </div>
      </draggable>
      <div class="card question">
        <div class="inputs">
          <div class="input full question-editor">
            <label>New Question</label>
            <editor v-model="question.question" />
          </div>

          <!-- <template v-if="question.answers.length">
            <div class="input full">
              <label>Answers</label>
            </div>
            <div
              class="input full answers"
              v-for="(answer, i) in question.answers"
              :key="i"
            >
              <div class="input-btn">
                <input v-model="answer.name" />
                <button @click="removeAnswer(i)" class="btn text_btn red">
                  Remove
                </button>
              </div>
            </div>
          </template> -->
          <!-- <div class="input full add-answer">
            <label>Add an Answer</label>
            <div class="input-btn">
              <input v-model="answer.name" />
              <button @click="addAnswer()" class="btn text_btn">
                + Add Answer
              </button>
            </div>
          </div> -->
          <div class="btns right">
            <button @click="addQuestion()" class="btn round-btn add-question">
              Add Question
            </button>
          </div>
        </div>
      </div>
      <!-- <div class='card' v-for='(cContact, i) in client.contacts'>
                <div class='inputs'>
                    <div class='input full'>
                        <label>Contact Name</label>
                        <input v-model='cContact.name'>
                    </div>
                    <div class='input full'>
                        <label>Contact Email</label>
                        <input v-model='cContact.email'>
                    </div>
                    <div class='input full'>
                        <label>Contact Phone</label>
                        <input v-model='cContact.phone'>
                    </div>
                    <div class='input full delete-btn'>
                        <p @click='deleteContact(i)' class='delete'>x</p>
                    </div>
                </div>
            </div> -->
      <button @click="validateForm()" class="btn round-btn">Save Form</button>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
import Swal from "sweetalert2";
import Switches from "vue-switches";
import draggable from "vuedraggable";
import CKEditor from "@/components/CKEditor.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  name: "Form",
  components: {
    register: Register,
    Switches,
    draggable,
    editor: CKEditor,
  },
  data() {
    return {
      helper: null,
      answer: {
        name: null,
        bad: null,
      },
      question: {
        question: null,
        answers: "",
      },
      form: {
        title: null,
        description: null,
        created_at: Date.now(),
        questions: [],
        attendee_status: false,
      },
      currently_editing: {},
      edit_init: false,
      dragging: false,
    };
  },
  created() {
    this.$bind(
      "form",
      db
        .collection("user")
        .doc(this.user_doc.id)
        .collection("forms")
        .doc(this.$route.params.id)
    ).then((form) => {
      if (form) {
        form.questions.map((question, i) => {
          this.currently_editing[i] = false;
        });
      } else if (!form) {
        this.form = {
          title: null,
          description: null,
          created_at: Date.now(),
          questions: [],
        };
      }
    });
  },
  methods: {
    addAnswer() {
      this.question.answers.push(this.answer);
      this.answer = {
        name: null,
        bad: null,
      };
    },
    removeAnswer(i) {
      this.question.answers.splice(i, 1);
    },
    addQuestion() {
      if (this.question.question) {
        if (this.unique_questions[this.question.question]) {
          Swal.fire("The text of your questions must all be unique!");
        } else {
          this.form.questions.push(this.question);
          this.question = {
            question: "",
            answers: "",
          };
        }
      } else {
        Swal.fire(
          "Can't add blank questions, please add content to your question and try again"
        );
      }
    },
    removeQuestion(i) {
      this.form.questions.splice(i, 1);
    },
    editQuestion(i) {
      this.currently_editing[i] = !this.currently_editing[i];
      this.$forceUpdate();
    },
    validateForm() {
      let valid = true;
      let form = this.form;
      let questions = this.form.questions;

      for (let key in form) {
        if (key == "title") {
          if (!form[key]) valid = false;
        }
      }

      if (questions.length > 1) {
        if (valid) {
          this.saveForm();
        } else {
          Swal.fire("You are missing form title");
        }
      } else {
        Swal.fire("You need at least 2 questions");
      }
    },
    saveForm() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      return Promise.resolve()
        .then(() => {
          if (this.form.id) {
            return this.$firestoreRefs.form.set(this.form, { merge: true });
          } else {
            const checkLimitAndCreate = functions.httpsCallable(
              "checkLimitAndCreate"
            );
            return checkLimitAndCreate({
              path: this.$firestoreRefs.form.path,
              field: "forms",
              payload: this.form,
            });
          }
        })
        .then(() => {
          loader.hide();
          return Swal.fire("This form has been saved!");
        })
        .then(() => {
          return this.goTo("/forms");
        })
        .catch((err) => {
          loader.hide();
          Swal.fire("Error", err.message, "error");
        });
    },
  },
  computed: {
    unique_questions() {
      let questions = {};
      this.form.questions.forEach((q) => (questions[q.question] = true));
      return questions;
    },
  },
};
</script>

<style scoped lang="scss">
.totals {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
  p {
    margin-left: 40px;
    font-size: 15px;
    span {
      font-size: 35px;
      font-weight: bold;
      font-family: "SFProDisplay", sans-serif;
      display: block;
    }
  }
}
h3 {
  margin-top: 30px;
}

.text_btn {
  text-decoration: underline;
}

.input-btn {
  display: flex;
  align-items: center;
  input {
    width: 100%;
  }
  .btn {
    flex: none;
    padding-top: 0;
  }
}

.add-answer {
  padding-top: 20px;
  margin-top: 20px;
  border-top: 2px solid #eaeaea;
}

.answers {
  input {
    margin-bottom: 6px !important;
    padding: 5px 15px !important;
    font-size: 15px !important;
  }
}

.add-question {
  margin-top: 30px;
}

h4 {
  margin-top: 0;
  font-weight: 500;
  padding-right: 87px;
  span {
    display: block;
    font-size: 25px;
    margin-top: 5px;
    font-weight: bold;
    p {
      margin: 0;
    }
  }
}

.question {
  padding: 15px 30px !important;
  position: relative;
  ul {
    margin-bottom: 0;
  }
  .controls {
    display: flex;
    position: absolute;
    right: 20px;
    top: 20px;
    align-items: center;
    img {
      height: 30px;
      margin-left: 20px;
      cursor: pointer;
    }
  }
}

.question:hover {
  cursor: pointer;
}
</style>
